import * as api from '../api/payNowManagement'
import { PayNowAuthorizationSucess, StatusInterface } from '../Interfaces/PayNow/AccountAuthorizationParams'
import { PayNowActions } from './actionTypes'
import { actionCreatorAsync } from './index'

export const loadPayNowAuthorizationStatus = () => {
  return actionCreatorAsync<boolean>(PayNowActions.LOAD_STATUS, () => api.getPayNowAuthorizationStatus())
}

export const savePayNowAuthorization = (payNowAuthorizationParams: PayNowAuthorizationSucess) => {
  return actionCreatorAsync<boolean>(PayNowActions.SAVE_AUTHORIZATION, () =>
    api.postPayNowAuthorization(payNowAuthorizationParams.code),
  )
}

export const updatePayNowStatus = (status: StatusInterface) => {
  return actionCreatorAsync<StatusInterface>(PayNowActions.UPDATE_STATUS_TOGGLE_ACTIVE, () =>
    api.putPayNowStatus(status),
  )
}

export const disconnectPayNow = () => {
  return actionCreatorAsync<StatusInterface>(PayNowActions.DISCONNECT, () => api.disconnectPayNow())
}
